import styled from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';

export const StyledSideBar = styled.aside`
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: ${({ $collapsed }) => ($collapsed ? '64px' : '280px')};
  background: #19191b;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  color: var(--white);
  transition: width 0.2s ease;

  @media (max-width: 1199px) {
    position: fixed;
    left: 0;
    width: ${({ $collapsed }) => ($collapsed ? '0' : '280px')};
    border-right: ${({ $collapsed }) => ($collapsed ? 'none' : '1px solid rgba(255, 255, 255, 0.08)')};
    box-shadow: ${({ $collapsed }) => ($collapsed ? 'none' : '0 0 20px rgba(0, 0, 0, 0.45)')};
    overflow: ${({ $collapsed }) => ($collapsed ? 'visible' : 'hidden')};
  }

  .nav-header {
    height: 64px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'space-between')};
    gap: 8px;
    padding: ${({ $collapsed }) => ($collapsed ? '0 8px' : '0 16px')};
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

    @media (max-width: 1199px) {
      padding-right: ${({ $collapsed }) => ($collapsed ? '0' : '16px')};
    }
  }

  .logo-link {
    display: flex;
    align-items: center;
    min-width: 0;

    .logo-lg {
      width: 130px;
      max-width: 100%;
      height: auto;
    }

    .logo-sm {
      width: 22px;
      height: auto;
    }
  }

  .collapse-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--light-gray);
    cursor: pointer;

    &:hover {
      color: var(--white);
      background: rgba(255, 255, 255, 0.06);
    }

    @media (max-width: 1199px) {
      position: ${({ $collapsed }) => ($collapsed ? 'fixed' : 'static')};
      top: ${({ $collapsed }) => ($collapsed ? '12px' : 'auto')};
      left: ${({ $collapsed }) => ($collapsed ? '12px' : 'auto')};
      z-index: 60;
      background: ${({ $collapsed }) => ($collapsed ? '#1a1a1a' : 'transparent')};
    }
  }

  .scroll-area {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px 0 0;
    display: flex;
    flex-direction: column;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.35);
    }
  }

  .sidebar-footer {
    flex: 0 0 auto;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    background: #19191b;
  }

  .nav-links {
    list-style: none;
    margin: 0;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    li {
      width: 100%;
    }

    a,
    .btn-logout {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'flex-start')};
      gap: 12px;
      padding: 8px 12px;
      border: 0;
      border-radius: 8px;
      background: transparent;
      color: var(--light-gray);
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      cursor: pointer;
      transition: background 0.2s ease, color 0.2s ease;

      &:hover {
        color: var(--white);
        background: rgba(255, 255, 255, 0.04);
      }

      &.active {
        color: var(--primary);
        background: rgba(3, 160, 141, 0.15);
      }
    }

    .icon {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
      color: inherit;
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: inherit;
    }
  }

  .chat-history {
    margin-top: 20px;
    padding: 0 8px;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      padding: 0 8px;
      margin-bottom: 8px;
      flex-shrink: 0;
    }

    .subheading {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #707070;
    }

    .agent-filter {
      position: relative;
    }

    .agent-trigger {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 0;
      border: 0;
      background: transparent;
      color: var(--text-color-50);
      font-size: 12px;
      cursor: pointer;

      &:hover {
        color: var(--white);
      }

      .agent-name {
        max-width: 96px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .sessions-wrap {
      padding: 0 4px;
    }
  }

  .secondary-nav {
    flex-shrink: 0;
    padding: 8px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  .profile-holder {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'flex-start')};
    gap: 12px;
    padding: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.03);
    }

    .profile-img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--primary);
      color: var(--white);

      .text {
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
      }
    }

    .profile-info {
      flex: 1;
      min-width: 0;

      .name {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: var(--white);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .text {
        display: block;
        font-size: 12px;
        color: var(--text-color-50);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .icon-arrow {
      flex-shrink: 0;
      color: var(--text-color-50);
    }
  }
`;

export const AgentMenuPanel = styled.div`
  position: fixed;
  z-index: 60;
  width: 200px;
  border-radius: 10px;
  background: #161616;
  border: 1px solid #2a2a2a;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  overflow: hidden;

  .search-wrap {
    position: relative;
    padding: 10px;
    border-bottom: 1px solid #2a2a2a;

    .search-icon {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      color: #606060;
      pointer-events: none;
    }

    input {
      width: 100%;
      background: #0e0e0e;
      border: 1px solid #333;
      border-radius: 6px;
      padding: 6px 10px 6px 32px;
      font-size: 12px;
      color: var(--white);
      outline: none;

      &::placeholder {
        color: #606060;
      }

      &:focus {
        border-color: #444;
      }
    }
  }

  .agent-list {
    max-height: 220px;
    overflow-y: auto;
    padding: 6px;

    .empty {
      margin: 0;
      padding: 12px 8px;
      font-size: 12px;
      color: #707070;
      text-align: center;
    }

    button {
      width: 100%;
      text-align: left;
      padding: 8px 10px;
      border: 0;
      border-radius: 6px;
      background: transparent;
      color: #a0a0a0;
      font-size: 12px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        color: var(--white);
      }

      &.selected {
        background: rgba(3, 160, 141, 0.15);
        color: var(--primary);
      }
    }
  }
`;

/** Shared by AgentProfile / CreatAgentModal (legacy imports) */
export const MenuBtn = styled(MenuButton)`
  position: relative;
  font-size: 14px;
  line-height: 20px;
  color: var(--black);
  border-radius: 5px;
  padding: 3px 10px;
  text-align: center;
  font-weight: 600;
  background: var(--white);
`;

export const ReponseMenu = styled(Menu)`
  box-shadow:
    0 0 7px rgba(0, 0, 0, 0.133),
    0 0 2px rgba(0, 0, 0, 0.1);

  ul {
    width: 100px;
    padding: 5px;
    border-radius: 5px;
    max-height: 250px;
    overflow-y: auto;

    .text {
      font-size: 14px;
      line-height: 17px;
    }
  }
  &.szh-menu-container {
    left: 0 !important;
    right: 0 !important;
  }
  .szh-menu {
    left: auto !important;
    right: 16px !important;
    z-index: 10 !important;
  }
`;

export const StyleItem = styled(MenuItem)`
  display: block;
  padding: 3px 6px;
  margin: 0 0 3px;
  border-radius: 3px;

  &.active,
  &:hover {
    background: var(--gray-100);
  }

  &:last-child {
    margin: 0;
  }
`;
